import { render, staticRenderFns } from "./SpamEmails.vue?vue&type=template&id=1edbf57c&scoped=true"
import script from "./SpamEmails.vue?vue&type=script&lang=js"
export * from "./SpamEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edbf57c",
  null
  
)

export default component.exports